module.exports = __webpack_public_path__ + "img/afterSales.2e9cf0fe.svg";